module.exports = __webpack_public_path__ + "img/logo-talentos-na-pista.c79527d2.svg";